import React from "react";
import ReactDOM from "react-dom/client";
import { RootApp } from "./RootApp";
import { BrandingProvider } from "./lib/brandingContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { applyDocumentLang, LanguageProvider } from "./lib/i18n";
import { installGlobalErrorHandlers, logger } from "./lib/logger";
import { DESIGN_GALLERY_ENABLED, isDesignGalleryPath } from "./lib/designGallery";
import { applyTheme, loadTheme } from "./lib/theme";
// tailwind.css pulls in base.css (tokens, globals) and components.css (shared v1 primitives).
import "./theme/tailwind.css";

// Before React paints: CSS text-transform: uppercase follows <html lang>.
// Default app language is English; stored TR preference applied immediately.
applyDocumentLang();

// Theme before paint so returning light users avoid a full dark flash after hydrate.
// Product screens default dark. The gallery is always light and has no toggle,
// so opening /design-system does not rewrite the product preference.
applyTheme(
  DESIGN_GALLERY_ENABLED && isDesignGalleryPath(window.location.pathname) ? "light" : loadTheme(),
);

installGlobalErrorHandlers();
logger.info("frontend boot");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <LanguageProvider>
      <ErrorBoundary>
        {/* Org-subdomain white-label (#85): cosmetic, never gates login. */}
        <BrandingProvider>
          <RootApp />
        </BrandingProvider>
      </ErrorBoundary>
    </LanguageProvider>
  </React.StrictMode>,
);
